module.exports = __webpack_public_path__ + "assets/img/camera-drone.813ca722.png";